import { combineReducers } from 'redux'
import last30Days from './last-30-days'
import past6Months from './past-6-months'
import pastXMonths from './past-x-months'
import currentPeriod from './current-period'
import bySourceForCurrentPeriod from './by-source-for-current-period'

export default combineReducers({
  last30Days,
  past6Months,
  pastXMonths,
  currentPeriod,
  bySourceForCurrentPeriod
})



// WEBPACK FOOTER //
// ./reducers/mtus/index.js